import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';


@Component({
  selector: 'app-unitedsdk',
  templateUrl: './unitedsdk.component.html',
  styleUrls: ['./unitedsdk.component.scss'],
  standalone: false
})
export class UnitedSDKComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'overview';

  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'problem', label: 'Problem', icon: 'bx-error-circle' },
    { id: 'features', label: 'Key Features', icon: 'bx-cog' },
    { id: 'usecases', label: 'Use Cases', icon: 'bx-grid-alt' },
    { id: 'impact', label: 'Business Impact', icon: 'bx-line-chart' },
    { id: 'all-features', label: 'All Features', icon: 'bx-list-ul' },
  ];

  overviewHighlights = [
    {
      val: 'Single Platform',
      label: 'One scalable SDK foundation across mobile applications and in vehicle systems.',
    },
    {
      val: 'Consistent Delivery',
      label: 'Trip tracking, safety, rewards, and driver insights delivered through one product layer.',
    },
    {
      val: 'Built to Scale',
      label: 'Designed for deployment across mobility products, enterprise programs, and connected vehicle ecosystems.',
    },
  ];

  keyFeatures = [
    'Unified SDK supporting mobile and in vehicle data capture',
    'Hardware agnostic and platform independent architecture',
    'Mileage, trip tracking, and route analytics',
    'Driver behavior analysis and scoring',
    'Turn by turn navigation and live route guidance',
    'SOS and emergency assistance with live location sharing',
    'Alerts, notifications, and driving insights',
    'Rewards and miles engine',
    'Ecosystem, marketplace, and partner integrations',
    'In vehicle app store enablement',
    'Screen mirroring to vehicle displays',
  ];

  useCases = [
    {
      icon: 'bx-car',
      title: 'Connected Driving Experience',
      desc: 'Deliver a seamless connected experience with trip history, live tracking, driving insights, and real time alerts across mobile and in vehicle interfaces.',
    },
    {
      icon: 'bx-shield-quarter',
      title: 'Driver Safety and Risk Monitoring',
      desc: 'Monitor harsh braking, acceleration, over speeding, and cornering to improve road safety and promote responsible driving habits.',
    },
    {
      icon: 'bx-file-find',
      title: 'Usage Based Insurance Enablement',
      desc: 'Support insurance providers with real world driving data for personalized risk assessment and data driven insurance models.',
    },
    {
      icon: 'bx-gift',
      title: 'Rewards and Engagement Programs',
      desc: 'Encourage better driving through reward mechanisms linked to mileage and driving behaviour, improving engagement and long term retention.',
    },
    {
      icon: 'bx-buildings',
      title: 'Fleet and Mobility Operations',
      desc: 'Track vehicle usage, trips, and driver performance to improve operational efficiency, reduce risk, and enhance fleet visibility.',
    },
    {
      icon: 'bx-wrench',
      title: 'Vehicle Health and Service Experience',
      desc: 'Provide timely alerts for service, maintenance, and usage patterns so vehicles can remain in optimal condition.',
    },
    {
      icon: 'bx-first-aid',
      title: 'Emergency Assistance and SOS Services',
      desc: 'Offer instant SOS functionality with live location sharing to support faster response during emergencies and improve driver confidence.',
    },
    {
      icon: 'bx-map',
      title: 'Navigation and Route Intelligence',
      desc: 'Enable turn by turn navigation, route optimization, and trip insights to improve daily driving convenience and efficiency.',
    },
    {
      icon: 'bx-store-alt',
      title: 'Digital Marketplace and Ecosystem Enablement',
      desc: 'Integrate maintenance, roadside assistance, and digital offerings through a connected marketplace experience.',
    },
    {
      icon: 'bx-devices',
      title: 'In Vehicle Digital Experience',
      desc: 'Enable access to apps, services, and mirrored mobile content directly on the vehicle display for a richer in vehicle experience.',
    },
  ];

  businessImpact = [
    'Faster launch of connected vehicle features',
    'Reduced development and integration complexity',
    'Consistent experience across platforms and devices',
    'Increased user engagement through insights and rewards',
    'New digital and ecosystem driven revenue opportunities',
    'Scalable platform ready for future mobility needs',
  ];

  allFeatures = [
    'Telematics data collection via mobile and in vehicle systems',
    'Mileage and trip tracking',
    'Trip analytics and route history',
    'Driver behavior monitoring and scoring',
    'Alerts and notifications',
    'SOS with live location sharing',
    'Turn by turn navigation',
    'Rewards and miles engine',
    'Vehicle data integration',
    'Service and maintenance reminders',
    'Ecosystem partner integrations',
    'Digital marketplace enablement',
    'In vehicle app store access',
    'Screen mirroring to vehicle displays',
    'Cloud based analytics and insights',
    'Hardware agnostic SDK framework',
  ];

  ngOnInit() {}


  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
